module.exports = __webpack_public_path__ + "media/images/recipes/picanha-f772fcbf4516ce4edc731f4c29685508.pdf";